import { fetchData } from './fetchData';
import { DefaultResponseData } from './data/DefaultResponseData';

export type UserDraftRequestData = {
    // LINE ID
    line_uid: string,
    // 帳號(E-mail)
    email: string,
    // 密碼
    password: string,
    // 公司/學校統編
    vat: string,
    // 公司/學校系所
    company_name: string,
    // 部門單位/老師實驗室
    customer_department: string,
    // 地址
    contact_address: string,
    // 姓名
    name: string,
    // 電話/手機
    phone: string,
};

function userDraft(data: UserDraftRequestData): Promise<DefaultResponseData> {
    return fetchData('api/user_draft', {
        method: 'POST',
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((resData: DefaultResponseData) => resData);
}

export { userDraft };
